<div class="dashboardHeader">
    <h4 class="dashboardHeading text-shadow">Student Gap Analysis</h4>
</div>

<div id="studentCharts" class="col-12 col-md-12 col-sm-12 p-0 cardContainer">
    <div class="col-12 col-md-12 col-sm-12 p-1 clearfix">
        <mat-radio-group class="example-radio-group countCardRadio" [(ngModel)]="favoriteSeason">
            <div class="col-6 col-md-2 col-sm-6 p-0 tile floatLeft">
                <div class="card CountCardItem" matTooltip="Students left to be added">
                    <h2>{{dashboardCounts?.notInitiated}}</h2>
                    <div class="col-12">
                        <p>Not Initiated</p>
                    </div>
                </div>
            </div>
            <div class="col-6 col-md-2 col-sm-6 p-0 tile floatLeft">
                <div class="card CountCardItem" matTooltip="Students added, but not registered">
                    <h2>{{dashboardCounts?.notRegistered}}</h2>
                    <div class="col-12">
                        <mat-radio-button class="example-radio-button" (change)="onCountsClick($event.value)" value="notRegistered">
                            <p>Not Registered</p>
                        </mat-radio-button>
                    </div>
                </div>
            </div>
            <div class="col-6 col-md-2 col-sm-6 p-0 tile floatLeft">
                <div class="card CountCardItem" matTooltip="Students whose profiles are not submitted">
                    <h2>{{dashboardCounts?.profileNotSubmitted}}</h2>
                    <div class="col-12">
                        <mat-radio-button class="example-radio-button" (change)="onCountsClick($event.value)" value="profileNotSubmitted">
                            <p>Profile Not Submitted</p>
                        </mat-radio-button>
                    </div>
                </div>
            </div>
            <div class="col-6 col-md-2 col-sm-6 p-0 tile floatLeft">
                <div class="card CountCardItem" matTooltip="Self-Registered students pending to be verified">
                    <h2>{{dashboardCounts?.notVerified}}</h2>
                    <div class="col-12">
                        <mat-radio-button class="example-radio-button" (change)="onCountsClick($event.value)" value="notVerified">
                            <p>Verification Pending</p>
                        </mat-radio-button>
                    </div>
                </div>
            </div>
            <div class="col-6 col-md-2 col-sm-6 p-0 tile floatLeft">
                <div class="card CountCardItem" matTooltip="Students whose profile is submitted but assessment is not assigned">
                    <h2>{{dashboardCounts?.assessmentNotAssigned}}</h2>
                    <div class="col-12">
                        <mat-radio-button class="example-radio-button" (change)="onCountsClick($event.value)" value="assessmentNotAssigned">
                            <p>Assessment not Assigned</p>
                        </mat-radio-button>
                    </div>
                </div>
            </div>
            <div class="col-6 col-md-2 col-sm-6 p-0 tile floatLeft">
                <div class="card CountCardItem" matTooltip="Students to whom assessment is assigned, but not taken">
                    <h2>{{dashboardCounts?.assessmentNotTaken}}</h2>
                    <div class="col-12">
                        <mat-radio-button class="example-radio-button" (change)="onCountsClick($event.value)" value="assessmentNotTaken">
                            <p>Assessment Not Taken</p>
                        </mat-radio-button>
                    </div>
                </div>
            </div>
        </mat-radio-group>
    </div>
    <div class="col-12 col-md-12 col-sm-12 p-1">
        <div *ngIf="favoriteSeason=='NotInitiated'" class="tabContentContainer">
        <div class="card contentCard">
            <div class="col-12 bb-2">
                <h4 class="graphHeading m-0"> Student Assessment Count - Monthwise</h4>
            </div>
            <div class="col-12 p-0">
    
            </div>
        </div>  
        </div>
        <div class="clearfix"></div>

        <div class="tabContentContainer">
            <div class="card contentCard">
                <div class="col-12 bb-2">
                    <h4 class="graphHeading m-0"> Student Assessments <small *ngIf="heading">( {{heading}} )</small></h4>
                </div>
                <div class="col-12 p-0">
                    <div class="row">
                        <div class="col-10 col-md-10 col-sm-10 col-xs-10" style="padding-top:15px;">
                            <mat-form-field appearance="outline" class="col-12">
                                <mat-label>Search in {{heading}} Students...</mat-label>
                                <input matInput (keyup)="applyFilter($event)" placeholder="Search..." #input>
                                <mat-icon matSuffix>search</mat-icon>
                            </mat-form-field>
                        </div>
                        <div class="col-2 col-md-2 col-sm-2 col-xs-2" style="margin-top:30px;">
                            <button mat-raised-button color="primary" class="float-left" (click)='exportAsExcelFile()'>Export Data</button>
                        </div>
                    </div>
                    <div class="example-container mat-elevation-z8">
                        <mat-table id="table" [dataSource]="dataSource" multiTemplateDataRows matSort #sort="matSort">
                    
                              <!-- StudentId Column -->
                            <ng-container id="serial" matColumnDef="StudentId">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Student Id </mat-header-cell>
                                <mat-cell *matCellDef="let element" (click)="expandedElement = expandedElement === element ? null : element"> {{element.student_id}} </mat-cell>
                            </ng-container>
                    
                            <!-- Name Column -->
                            <ng-container matColumnDef="Name">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
                                <mat-cell *matCellDef="let element" (click)="expandedElement = expandedElement === element ? null : element"> {{element.name}} </mat-cell>
                            </ng-container>
                    
                            <!-- Discipline Column -->
                            <ng-container matColumnDef="Discipline">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Discipline </mat-header-cell>
                                <mat-cell *matCellDef="let element" style="text-align: center;" (click)="expandedElement = expandedElement === element ? null : element"> {{element.course}} </mat-cell>
                            </ng-container>
                    
                            <!-- Batch Column -->
                            <ng-container matColumnDef="Batch">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Batch </mat-header-cell>
                                <mat-cell *matCellDef="let element" (click)="expandedElement = expandedElement === element ? null : element"> {{element.date_of_addmission}} </mat-cell>
                            </ng-container>
                    
                            <!-- Year Column -->
                            <ng-container matColumnDef="Year">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Current Year </mat-header-cell>
                                <mat-cell *matCellDef="let element" (click)="expandedElement = expandedElement === element ? null : element"> {{element.current_year}} </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="ContactInfo">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Contact Info </mat-header-cell>
                                <mat-cell *matCellDef="let element">
                                    <mat-icon (click)="expandedElement = expandedElement === element ? null : element">{{expandedElement === element
                                        ? 'contact_phone' : 'contact_phone'}}</mat-icon>
                                </mat-cell>
                            </ng-container>

                            <!-- Expanded Content Column - The detail row is made up of this one column -->
                            <ng-container matColumnDef="expandedDetail">
                                <mat-cell *matCellDef="let detail; let element">
                                    <ul class="expandedDetailList" style="float: left; margin-left: 25px;">

                                        <!-- Email Column -->
                                        <li class="expandedDetailListItem"> 
                                            <span class="expandedDetailTitle">Email</span>
                                            <span class="expandedDetailData">{{element.email}}</span>
                                        </li>

                                        <!-- Mobile Column -->
                                        <li class="expandedDetailListItem"> 
                                            <span class="expandedDetailTitle">Mobile</span>
                                            <span class="expandedDetailData">{{element.mobile}}</span>
                                        </li>
                                    </ul>
                                </mat-cell>
                            </ng-container>
                    
                            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row"></mat-row>
                            <mat-row *matRowDef="let row; columns: ['expandedDetail'];"
                                [@detailExpand]="row == expandedElement ? 'expanded' : 'collapsed'" style="overflow: hidden">
                            </mat-row>
                            
                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" style="padding-top:20px; padding-bottom:20px; background: white;">No data matching the filter "{{input.value}}"</td>
                            </tr>
                        </mat-table>
                        <mat-paginator class="paginator" #MatPaginator pageSize="5"></mat-paginator>
                    </div>
                </div>
            </div>  
        </div>
        <div class="clearfix"></div>

        <div *ngIf="favoriteSeason=='ProfileNotSubmitted'" class="tabContentContainer">
        <div class="card contentCard">
            <div class="col-12 bb-2">
                <h4 class="graphHeading m-0"> Student Assessments <small>Status</small></h4>
            </div>
            <div class="col-12 p-0">
    
            </div>
        </div>  
        </div>
        <div class="clearfix"></div>

        <div *ngIf="favoriteSeason=='VerificationPending'" class="tabContentContainer">
        <div class="card contentCard">
            <div class="col-12 bb-2">
                <h4 class="graphHeading m-0"> Student Assessments <small>Status</small></h4>
            </div>
            <div class="col-12 p-0">
    
            </div>
        </div>  
        </div>
        <div class="clearfix"></div>

        <div *ngIf="favoriteSeason=='AssessmentNotAssigned'" class="tabContentContainer">
        <div class="card contentCard">
            <div class="col-12 bb-2">
                <h4 class="graphHeading m-0"> Student Assessments <small>Status</small></h4>
            </div>
            <div class="col-12 p-0">
    
            </div>
        </div>  
        </div>
        <div class="clearfix"></div>

        <div *ngIf="favoriteSeason=='AssessmentNotTaken'" class="tabContentContainer">
        <div class="card contentCard">
            <div class="col-12 bb-2">
                <h4 class="graphHeading m-0"> Student Assessments <small>Status</small></h4>
            </div>
            <div class="col-12 p-0">
    
            </div>
        </div>  
        </div>
        <div class="clearfix"></div>
    </div>
</div>


<div class="card CardItem m-2">
    <div class="col-12 p-0 row" style="margin-left: 3px;" >
        <div class="col-8 " style="height: 67px; margin-top: 5px;">
            <h4 class="graphHeading m-0">GAPS <small>in the Institution</small></h4>
        </div>
        <div class="col-4" style="height: 67px; margin-top: 5px;">
            <mat-form-field appearance="outline" class="w-100 p-0">
                <mat-label>Department</mat-label>
                <mat-icon matPrefix class="mat-icon-sm mb-2 mr-2 secondary-text-color">account_circle
                </mat-icon>
                <mat-select [(ngModel)]="totalParticipationDept" (selectionChange)="onDeptChangeforAll($event)">
                    <mat-option value=0>All</mat-option>
                    <mat-option *ngFor="let dept of departments" [value]="dept?.id">{{dept?.department}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <!-- <div class="col-12 col-md-12 col-sm-12 bb-2">
        <div class="col-6 p-0">
        <h4 class="graphHeading m-0">GAPS <small>in the Institutions</small></h4>
        </div>
        <div class="col-6"></div>
    </div> -->
    <div class="col-12 col-md-12 col-sm-12 p-0">
        <div class="col-12 col-md-8 col-sm-12 floatLeft p-0">
        <div class="card CardItem">
            <h6 class="graphInnerHeading">Student Assessments <small style="padding-left: 10px;">Month-Wise (Having Score less 40)</small></h6>
            <apx-chart
            [series]="StudentFacultyAssessment.series"
            [chart]="StudentFacultyAssessment.chart"
            [dataLabels]="StudentFacultyAssessment.dataLabels"
            [plotOptions]="StudentFacultyAssessment.plotOptions"
            [yaxis]="StudentFacultyAssessment.yaxis"
            [legend]="StudentFacultyAssessment.legend"
            [fill]="StudentFacultyAssessment.fill"
            [stroke]="StudentFacultyAssessment.stroke"
            [tooltip]="StudentFacultyAssessment.tooltip"
            [xaxis]="StudentFacultyAssessment.xaxis"
            style="flex-grow: 1"
            ></apx-chart>
        </div>
        </div>
        <div class="col-12 col-md-4 col-sm-12 floatLeft p-0">
            <div *ngIf="!departmentPerformance || departmentPerformance.length === 0" class="card CardItem">
                <h6 class="graphInnerHeading">Low Performing Disciplines</h6>
                <h5 style="text-align: center; color: #73879C; padding-top: 35px;">No Data</h5>
                <div class="col-12" fxFlex="100" style="margin-bottom: 15px;">
                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </div>
            </div>
            <div *ngIf="departmentPerformance.length!=0" class="card CardItem">
                <h6 class="graphInnerHeading">Low Performing Disciplines</h6>
                <div *ngFor="let dept of departmentPerformance;let i=index" class="progressBarContainer">
                    <p *ngIf="i<=8" class="progressBarHeading">{{dept?.department}}</p>
                    <mat-progress-bar *ngIf="i<=8"
                        class="example-margin"
                        color="#26B99A"
                        mode="determinate"
                        value="{{dept?.avg}}"
                    >
                    </mat-progress-bar>
                    <div *ngIf="i<=8" class="progressBarCount">{{dept?.avg}}%</div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="clearfix"></div>

<div class="col-12 col-md-12 col-sm-12 p-0 mb-4">
    <div class="col-12 col-md-12 col-sm-12 p-0 d-flex">
        <div class="col-12 col-md-4 col-sm-12 floatLeft p-0">
            <div class="CardItem h-100">
                <h6 class="graphInnerHeading">Students Performance</h6>
                <div class="col-12 mt-2">
                    <select class="form-control chartDropdown" [(ngModel)]="studentPerformanceDept" (change)="onDepartmentSelect($event)">
                        <option value=0>All</option>
                        <option *ngFor="let dept of departments" [value]="dept?.id">{{dept?.department}}</option>
                    </select>
                </div>
                <div *ngIf="!ratings">
                    <h4 style="text-align: center; color: #73879C; padding-top: 25px;">No performance data</h4>
                </div>
                <div *ngIf="ratings">
                    <p class="ratingHeading">Rating</p>
                    <div class="ratingProgressBarContainer">
                    <p class="ratingProgressBarHeading">0-10</p>
                    <mat-progress-bar
                        class="example-margin"
                        mode="determinate"
                        value="{{ratings['perc1']}}"
                    >
                    </mat-progress-bar>
                    <div class="ratingProgressBarCount">{{ratings['rating1']}}</div>
                    </div>
                    <div class="ratingProgressBarContainer">
                    <p class="ratingProgressBarHeading">10-20</p>
                    <mat-progress-bar
                        class="example-margin"
                        mode="determinate"
                        value="{{ratings['perc2']}}"
                    >
                    </mat-progress-bar>
                    <div class="ratingProgressBarCount">{{ratings['rating2']}}</div>
                    </div>
                    <div class="ratingProgressBarContainer">
                    <p class="ratingProgressBarHeading">20-30</p>
                    <mat-progress-bar
                        class="example-margin"
                        mode="determinate"
                        value="{{ratings['perc3']}}"
                    >
                    </mat-progress-bar>
                    <div class="ratingProgressBarCount">{{ratings['rating3']}}</div>
                    </div>
                    <div class="ratingProgressBarContainer">
                    <p class="ratingProgressBarHeading">30-40</p>
                    <mat-progress-bar
                        class="example-margin"
                        mode="determinate"
                        value="{{ratings['perc4']}}"
                    >
                    </mat-progress-bar>
                    <div class="ratingProgressBarCount">{{ratings['rating4']}}</div>
                    </div>
                </div>
            </div>
            <div class="clearfix"></div>
        </div>
        <div class="col-12 col-md-4 col-sm-12 floatLeft p-0">
            <div class="CardItem h-100">
                <h6 class="graphInnerHeading">Low Performing Specializations</h6>
                <div class="col-12 mt-2">
                    <select class="form-control chartDropdown" [(ngModel)]="topSpecsDept" (change)="onDeptChangeTopic($event)">
                        <option *ngFor="let dept of departments" [value]="dept?.id">{{dept?.department}}</option>
                    </select>
                </div>
                <div *ngIf="Specializations['series'][0]">
                <apx-chart id="Specializations"
                    [series]="Specializations.series"
                    [chart]="Specializations.chart"
                    [labels]="Specializations.labels"
                    [fill]="Specializations.fill"
                    [plotOptions]="Specializations.plotOptions"
                    [colors]="Specializations.colors"
                    [dataLabels]="Specializations.dataLabels"
                    [responsive]="Specializations.responsive"
                    style="top: 10px"
                ></apx-chart>
                </div>
                <div *ngIf="!Specializations['series'][0]">
                    <h4 style="text-align: center; color: #73879C; padding-top: 25px;">No Specializations Data</h4>
                    <div class="col-12" fxFlex="100" style="margin-bottom: 15px;">
                        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                    </div>
                </div>
            </div>
            <div class="clearfix"></div>
        </div>
        <div class="col-12 col-md-4 col-sm-12 floatLeft p-0">
            <div class="CardItem h-100">
                <h6 class="graphInnerHeading">Total Participation</h6>
                <div class="col-12 mt-2">
                <select class="form-control chartDropdown" [(ngModel)]="totalParticipationDept" (change)="onDeptChangeParticipants($event)">
                    <option value=0>All</option>
                    <option *ngFor="let dept of departments" [value]="dept?.id">{{dept?.department}}</option>
                </select>
                </div>
                <div class="ParticipationChartContainer">
                <apx-chart
                    [series]="TotalParticipation.series"
                    [chart]="TotalParticipation.chart"
                    [plotOptions]="TotalParticipation.plotOptions"
                    [labels]="TotalParticipation.labels"
                    [colors]="TotalParticipation.colors"
                >
                </apx-chart>
                <div class="ParticipationChartValBox">
                    <p>{{totalParticipation?.totalAssessmentCount}}</p>
                    <p>{{totalParticipation?.totalStudentsAdded}}</p>
                </div>
                </div>
            </div>
            <div class="clearfix"></div>
        </div>
    </div>
    <div class="clearfix"></div>
</div>
<div class="clearfix"></div>

<div #graphArea class="col-12 p-1 mb-2">
    <div class="card contentCard">
        <h6 class="graphInnerHeading m-0">
            Number of students having score less than 40
        </h6>
        <apx-chart
            [series]="GraphArea.series"
            [chart]="GraphArea.chart"
            [xaxis]="GraphArea.xaxis"
            [yaxis]="GraphArea.yaxis"
            [stroke]="GraphArea.stroke"
            [tooltip]="GraphArea.tooltip"
            [dataLabels]="GraphArea.dataLabels"
            [colors]="GraphArea.colors"
            [markers]="GraphArea.markers"
            [legend]="GraphArea.legend"
        ></apx-chart>
    </div>
</div>
<div class="clearfix"></div>



